module.exports = __webpack_public_path__ + "static/media/fork.0ee52fb6.png";